





































import moment from "moment";
import DistanceLine from "./DistanceLine.vue";

export default {
    name: "DistanceViewer",
    props: { distances: Array },
    components: { DistanceLine },
    data() {
        return {
            dates: [],
            selectedDay: null,
        };
    },
    computed: {
        grouppedTrajets: function () {
            return _.groupBy(this.distances, "date");
        },
    },
    methods: {
        populateDates: function () {
            let self = this;
            self.dates = [];
            _.forEach(self.grouppedTrajets, function (value, key) {
                var totalDist = _.reduce(
                    value,
                    function (sum, trajet) {
                        return sum + trajet.distance.distance / 1000;
                    },
                    0
                );
                var validated = true;
                _.forEach(value, function (trajet) {
                    if (trajet.distance.status === 0) {
                        validated = false;
                        return false;
                    }
                });
                self.dates.push({
                    key: key,
                    dateStr: moment(key, "YYYY-MM-DD").format("DD/MM/YYYY"),
                    totalDistStr: _.round(totalDist, 2) + " km",
                    validated: validated,
                });
            });
        },
        onDistanceUpdate: function (distance) {
            _.each(this.distances, function (t) {
                if (t.distance.id === distance.id) {
                    t.distance = distance;
                }
            });
            this.populateDates();
        },
    },
    watch: {
        distances: {
            immediate: true,
            handler: function (newVal) {
                this.populateDates();
            },
        },
    },
};
